import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-zinc-50 border-t border-zinc-200" data-testid="footer">
      <div className="max-w-7xl mx-auto container-padding py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <h3 
              className="text-2xl font-semibold tracking-tight mb-4"
              style={{ fontFamily: 'Outfit, sans-serif' }}
            >
              VANTAGE
            </h3>
            <p className="text-zinc-600 max-w-sm">
              Premium print-on-demand designs for creators who want to stand out. 
              AI-powered generation meets curated marketplace.
            </p>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-medium mb-4 overline">Explore</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/marketplace" className="text-zinc-600 hover:text-zinc-900 transition-colors">
                  Marketplace
                </Link>
              </li>
              <li>
                <Link to="/generator" className="text-zinc-600 hover:text-zinc-900 transition-colors">
                  AI Generator
                </Link>
              </li>
              <li>
                <Link to="/auth" className="text-zinc-600 hover:text-zinc-900 transition-colors">
                  Sign Up
                </Link>
              </li>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h4 className="font-medium mb-4 overline">Categories</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/marketplace?category=minimal" className="text-zinc-600 hover:text-zinc-900 transition-colors">
                  Minimal
                </Link>
              </li>
              <li>
                <Link to="/marketplace?category=vintage" className="text-zinc-600 hover:text-zinc-900 transition-colors">
                  Vintage
                </Link>
              </li>
              <li>
                <Link to="/marketplace?category=streetwear" className="text-zinc-600 hover:text-zinc-900 transition-colors">
                  Streetwear
                </Link>
              </li>
              <li>
                <Link to="/marketplace?category=abstract" className="text-zinc-600 hover:text-zinc-900 transition-colors">
                  Abstract
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="divider"></div>

        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-zinc-500">
            © {new Date().getFullYear()} VANTAGE. All rights reserved.
          </p>
          <div className="flex gap-6">
            <a href="#" className="text-sm text-zinc-500 hover:text-zinc-900 transition-colors">
              Privacy
            </a>
            <a href="#" className="text-sm text-zinc-500 hover:text-zinc-900 transition-colors">
              Terms
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
